import Products from 'pages/Settings/Products/shared/components/Products'
import { bakersProductsAdapter } from 'pages/Settings/Products/shared/adapters/bakers'

export const BakersProductsPage = () => {
  return <Products adapter={bakersProductsAdapter} />
}
